import React, { useState, useEffect } from "react";
import LayoutWrapper from "@iso/components/utility/layoutWrapper.js";
import Box from "@iso/components/utility/box";
import InspectionWrapper from "./Inspection.styles";
import IntlMessages from "@iso/components/utility/intlMessages";
import { Button, Dropdown, Menu, message, Col, Modal, Select, Row, Input, Tag } from "antd";
import {
  SearchOutlined,
  CloseCircleOutlined,
  DownOutlined,
  EditOutlined,
  UserOutlined,
  SendOutlined,
  EllipsisOutlined,
  LogoutOutlined
} from "@ant-design/icons";
import {
  propertyService,
  profileService,
  visitorInfoService,
  userFormService,
} from "@iso/services";
import { visitorFormService } from "../../../services/visitorform.service";
import { visitorInductionService } from "@iso/services";
import _ from "lodash";
import Table from "@iso/components/collapsing-table/table";
import { userTypes } from "@iso/constants/userTypes";
import VisitorModal from "@iso/containers/Pages/Visitor/VisitorModal";
import VisitorInfoModal from "@iso/containers/Pages/Visitor/VisitorInfoModal";
import CheckinUserProfileModal from "@iso/containers/Pages/Profile/CheckinUserProfileModal";
import ViewSurveyResultModal from "./ViewSurveyResultModal";
import ViewServeyVisitoModal from "./ViewServeyVisitoModal";

const pageSize = 15;
/**
 * How many submissions a row represents.
 *
 * `global_form_submission` is a LIST for schema forms — one entry per
 * submission, appended each time — but legacy rows hold a single object, and
 * older survey forms have none at all and count through answer_list instead.
 * A row that exists at all is at least one submission, so nothing renders 0.
 */
/**
 * Mirrors FormSubmission::SOURCE_LABELS on the backend.
 *
 * An unrecognised value falls through to itself rather than rendering blank —
 * a channel added on the server should show up here as something, not vanish.
 */
const SOURCE_LABELS = {
  web: 'Web',
  whatsapp: 'WhatsApp',
  mobile: 'Mobile app',
};

/**
 * Every channel this row's submissions arrived through, newest first.
 *
 * Derived from the submissions the row already carries rather than from a new
 * field — the payload has them, and one person can legitimately have used more
 * than one channel. Rows with nothing recorded return empty, and the column
 * shows a dash: submissions that predate the column genuinely do not know where
 * they came from, and most of them being web is exactly what would make
 * guessing "Web" convincing and wrong.
 */
const sourcesOf = (row) => {
  const submissions = Array.isArray(row?.form_submissions) ? row.form_submissions : [];

  return [...new Set(
    submissions
      .slice()
      .reverse()
      .map((submission) => submission && submission.source)
      .filter(Boolean)
  )];
};

const countSubmissions = (row) => {
  const submissions = row?.global_form_submission;

  if (Array.isArray(submissions)) {
    return submissions.length || 1;
  }

  if (submissions && typeof submissions === 'object') {
    return 1;
  }

  if (Array.isArray(row?.answer_list) && row.answer_list.length) {
    return row.answer_list.length;
  }

  return 1;
};

const Inspection = (props) => {

  const [visibleViewSurveyResult, setVisibleViewSurveyResult] = useState(false);

  const [totalPages, setTotalPages] = useState();
  const [totalUserFormPages, setTotalUserFormPages] = useState(0);
  const [totalVisitorFormPages, setTotalVisitorFormPages] = useState(0);
  const [currentPage, setCurrentPage] = useState();
  const [surveyResult, setSurveyResult] = useState({});
  const [surveyVisitorResult, setSurveyVisitorResult] = useState({});
  const [visitor, setVisitor] = React.useState({});
  const [visitorInfo, setVisitorInfo] = React.useState({});
  const [visibleCheckinUserProfileModal, setVisibleCheckinUserProfileModal] = React.useState(false);
  const [checkinUserId, setCheckinUserId] = React.useState(null);
  const [visibleVisitorModal, setVisibleVisitorModal] = React.useState(false);
  const [visibleVisitorInfoModal, setVisibleVisitorInfoModal] = React.useState(false);
  const [visibleViewServeyVisitoModal, setVisibleViewServeyVisitoModal] = React.useState(false);
  
  const [userFormList, setUserFormList] = useState([]);
  const [visitorFormList, setVisitorFormList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [searchQuery, setSearchQuery] = React.useState();
  const [searchInput, setsearchInput] = React.useState('');
  const [selectedUserType, setSelectedUserType] = useState("registered_user");
  const { Option } = Select;

  const menu = (userForm) => (
    
    <Menu onClick={handleMenuClick.bind(this, userForm)}>
      {(userForm.is_investigated || userForm.visitor_id) &&
        (userForm.form.type === "self_create" ||
          userForm.form.type === "system_forms" ||
          userForm.form.type === "checkin_form" ||
          userForm.form.type === "bio_form") && (
          <Menu.Item key="viewResult" icon={<EditOutlined />}>
            View Result
          </Menu.Item>
        )}
      {userForm.form_induction && userForm.form_induction.form_submission_id && (
        <Menu.Item key="viewInductionResult" icon={<EditOutlined />}>
          View Induction Result
        </Menu.Item>
      )}
      {userForm.visitor && (
        <>
          <Menu.Item key="viewResultVisitor" icon={<UserOutlined />}>
            View Result Visitor
          </Menu.Item>
          <Menu.Item key = "viewVisitorInfo" icon={<EditOutlined />}>
            View Visitor Info 
          </Menu.Item>
        </>
      )}
      {userForm.visitor_info && (
        <Menu.Item key="viewVisitor" icon={<UserOutlined />}>
          View Visitor
        </Menu.Item>
      )}
      {userForm.user_info && userForm.user_info.share_with_property_owner ? (
        <Menu.Item key="viewProfile" icon={<UserOutlined />}>
          View Profile
        </Menu.Item>
      ) : (
        <></>
      )}
      {userForm.user_info && !userForm.user_info.share_with_property_owner ? (
        <Menu.Item key="requestShareProfile" icon={<SendOutlined />}>
          Request To See Profile
        </Menu.Item>
      ) : (
        <></>
      )}
      {userForm.signature_path && (
        <Menu.Item key="viewSignature" icon={<EditOutlined />}>
          View Signature
        </Menu.Item>
      )}
      {userForm?.visitor && !userForm?.checkout_time && (
        <Menu.Item key="checkOutVisitor" icon={<LogoutOutlined />}>
          Checkout
        </Menu.Item>
      )}
    </Menu>
  );

  const showViewSurveyResult = (item) => {
    setSurveyResult(item);
    setVisibleViewSurveyResult(true);
  };

  // The INDUCTION's answers, not the visitor's check-in. Both hang off the same
  // visitor row, and "View Result Visitor" shows the check-in — so an induction
  // needs its own entry or it silently shows the wrong submission.
  //
  // Fetches the answers with the schema snapshot taken when they were submitted,
  // and hands ViewSurveyResultModal the same shape every other caller uses.
  const showInductionResult = (row) => {
    const induction = row && row.form_induction;
    if (!induction || !induction.id) {
      return;
    }
    visitorInductionService
      .getSubmission(induction.id)
      .then((res) => {
        if (!res || !res.success) {
          message.error((res && res.message) || "Could not load the induction answers");
          return;
        }
        const sub = res.data.submission;
        showViewSurveyResult({
          form: { name: induction.form_name, schema_json: sub.schema_json },
          user: sub.submitter_name || row.name || "Visitor",
          agree_date: sub.submitted_at,
          global_form_submission: [
            {
              ...(sub.answers || {}),
              submisison_date: sub.submitted_at,
              _schema: sub.schema_json || null,
            },
          ],
        });
      })
      .catch(() => message.error("Could not load the induction answers"));
  };

  const showViewServeyVisitoModal = (item) => {
    // New (schema_json) forms: show the visitor's filled form via the SAME modal a
    // registered user uses (ViewSurveyResultModal renders the actual submitted form),
    // not the old hardcoded visitor view. Legacy forms keep ViewServeyVisitoModal.
    const schema = item && item.form && item.form.schema_json;
    const isSchemaForm = !!(schema && Array.isArray(schema.steps) && schema.steps.length);
    if (isSchemaForm) {
      showViewSurveyResult(item);
      return;
    }
    setSurveyVisitorResult(item);
    setVisibleViewServeyVisitoModal(true);
  };

  const checkOutVisitor = (data) => {
    visitorInfoService.checkOutById(data.id)
      .then((res) => {
        if (res.code === "0000") {
          message.success(res.message);
        } else {
          message.error(res.message);
        }
      });
  }

  const handleMenuClick = (userForm, e) => {
    if (e.key === "viewResult") {
      showViewSurveyResult(userForm);
    }
    if (e.key === "viewInductionResult") {
      showInductionResult(userForm);
      return;
    }
    if(e.key ==="viewResultVisitor"){
      showViewServeyVisitoModal(userForm);
    }
    if (e.key === "viewVisitor") {
      setVisitor(userForm.visitor_info);
      setVisibleVisitorModal(true);
    }
    if(e.key === "viewVisitorInfo"){
      setVisitorInfo(userForm);
      setVisibleVisitorInfoModal(true);
    }
    if (e.key === "viewProfile") {
      setVisibleCheckinUserProfileModal(true);
      setCheckinUserId(userForm.user_id);
      setSelectedFormId(userForm.form_id);
    }
    if (e.key === "requestShareProfile") {
      profileService
        .requestShareProfile(userForm.form_id, userForm.user_id)
        .then((res) => {
          // Guard: the service resolves to undefined on a non-200 response.
          if (res && res.code === "0000") {
            message.success(res.message);
          } else if (res && res.message) {
            message.error(res.message);
          }
        });
    }
    if (e.key === "viewSignature") {
      setPreviewImage(userForm?.signature_path);
      setPreviewOpen(true);
    }
    if(e.key === "checkOutVisitor"){
      checkOutVisitor(userForm);
    }
  };

  const columns = [
    {
      label: <IntlMessages id="Name" />,
      accessor: "user",
      minWidth: 200,
      sortable: true,
      position: 1,
      priorityLevel: 1,
      CustomComponent: (cell) => {
        let row = cell.row;
        return <b>{row.user ? row.user : row.name}</b>;
      },
    },
    {
      minWidth: 100,
      label: <IntlMessages id="User Type" />,
      accessor: "userType",
      sortable: false,
      position: 2,
      priorityLevel: 2,
      CustomComponent: (cell) => {
        let row = cell.row;
        const label = row.visitor ? "Visitor" : "Registered User";
        // A form can be filled BOTH as a check-in and as an induction, and the
        // rows are otherwise identical. form_induction is set only when the list
        // is scoped to this form (see VisitorInfoController::preloadRows).
        return (
          <>
            {label}
            {row.form_induction && (
              <Tag color="green" style={{ marginLeft: 6 }}>
                Induction
              </Tag>
            )}
          </>
        );
      },
    },
    {
      minWidth: 100,
      label: <IntlMessages id="Submissions" />,
      accessor: "submissionCount",
      sortable: false,
      position: 3,
      priorityLevel: 3,
      // How many times this person submitted, not what kind of form it is. The
      // form's type is the same on every row of this table — it is one form —
      // so the column spent its width repeating "Self Create" while the one
      // number a reader wants was nowhere.
      CustomComponent: (cell) => <>{countSubmissions(cell.row)}</>,
    },
    {
      minWidth: 100,
      label: <IntlMessages id="Via" />,
      accessor: "source",
      sortable: false,
      position: 4,
      priorityLevel: 4,
      CustomComponent: (cell) => {
        const sources = sourcesOf(cell.row);

        if (!sources.length) {
          return <span style={{ color: '#bbb' }}>—</span>;
        }

        return (
          <>
            {sources.map((source) => (
              <Tag key={source} color={source === 'whatsapp' ? 'green' : 'default'}>
                {SOURCE_LABELS[source] || source}
              </Tag>
            ))}
          </>
        );
      },
    },
    {
      minWidth: 100,
      label: <IntlMessages id="Completed At" />,
      // completed_at, NOT updated_at: updated_at is a row-mutation stamp that gets
      // bumped for every row on the form (e.g. when the invited-user list is
      // re-saved), so it showed one identical time for every submission.
      accessor: "completed_at",
      sortable: true,
      position: 4,
      priorityLevel: 4,
      CustomComponent: (cell) => {
        let row = cell.row;
        // An induction-only row was never a check-in on this form, so it has no
        // completed_at of its own — the induction's completion is the answer.
        return row.completed_at || (row.form_induction && row.form_induction.completed_at) || "-";
      },
    },
    {
      label: "Action",
      accessor: "dot-menu",
      minWidth: 100,
      // Not a value — there is nothing to order by, and a clickable header here
      // sent the server a sort on a column that does not exist.
      sortable: false,
      position: 4,
      priorityLevel: 4,
      noTitle: true,
      CustomComponent: (cell) => {
        let row = cell.row;
        // let permission = permissionService.getPermission(row.permission_id);
        return (
          <Dropdown overlay={menu(row)} trigger={["click"]}>
            <div
              className="property-area-dot-btn"
              style={{ cursor: "pointer" }}
            >
              <EllipsisOutlined className="dotIcon"/>
            </div>
          </Dropdown>
        );
      },
    },
  ];

  const handleChange = (params = {}) => {
    const page = params.page ? params.page : 1;
    setCurrentPage(page);

    // Update the search input in the params
    params.search = searchInput;

    // Only the VISIBLE tab. The two lists come from different endpoints and
    // page independently, so fetching both on every page change made two
    // requests to serve the one list on screen — and paged a list nobody was
    // looking at.
    if (selectedUserType === "visitor") {
      getVisitorForms(params);
    } else {
      getUserForms(params);
    }
  };

  const getUserForms = (params = {}) => {
    params.is_pagination = 1;
    params.search = searchInput; // Include the search query
    userFormService.getList(props.formId, params)
      .then((res) => {
        if (res.code === "0000") {
          setTotalUserFormPages(res.total_page);
          setUserFormList(res.user_forms);
        }
      });
  };


  
  const getVisitorForms = (params = {}) => {
    params.search = searchInput; // Include the search query
    visitorInfoService.getList(props.formId, params)
      .then((res) => {
        if (res.code === "0000") {
          setTotalVisitorFormPages(res.total_page);
          setVisitorFormList(res.visitors);
        }
      });
  };



  // Switching tabs loads that tab's list, so the other endpoint is only called
  // when its list is actually about to be shown.
  useEffect(() => {
    if (!props.formId) {
      return;
    }

    if (selectedUserType === "visitor") {
      getVisitorForms();
    } else {
      getUserForms();
    }
  }, [props.formId, selectedUserType]);

  const getDataSource = () => {
    if (selectedUserType == "visitor") {
      return visitorFormList;
    } else {
      return userFormList;
    }
  };

  const closePreviewModal = () => {
    setPreviewOpen(false);
    setPreviewImage("");
  };

  const cancelVisitorlModal = () => {
    setVisibleVisitorModal(false);
    setVisitor({});
  };

  const cancelCheckinUserProfileModal = () => {
    setVisibleCheckinUserProfileModal(false);
    setCheckinUserId(null);
  };

  const renderUserTypeOptions = () => {
    let options = [];
    _.forEach(userTypes, (userType, index) => {
      options.push(
        <Option key={index} value={userType.value} className="property-option">
          {userType.label}
        </Option>
      );
    });
    return (
      <Select
        placeholder="Select User Type"
        value={selectedUserType}
        size="large"
        style={{ width: 170 }}
        onChange={(value) => {
          // Back to page 1: the two lists have different lengths, so keeping
          // the page number lands on an empty page whenever the tab you switch
          // to has fewer pages than the one you left.
          setCurrentPage(1);
          setSelectedUserType(value);
        }}
      >
        {options}
      </Select>
    );
  };

  const cancelViewSurveyResult = () => {
    setSurveyResult({});
    setVisibleViewSurveyResult(false);
  };
  const cancelViewServeyVisitoModal = () =>{
    setVisibleViewServeyVisitoModal(false);
  }

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
  };

  const handleCancelSearch = () => {
    setsearchInput('');
  };

  const cancelVisitorInfolModal = () => {
    setVisibleVisitorInfoModal(false);
    setVisitorInfo({});
  };

  return (
    <LayoutWrapper>
      <InspectionWrapper>

        <div className="mainDiv">



          <Input
            placeholder="Search…"
            suffix={!searchInput && <SearchOutlined className="site-form-item-icon" />}
            prefix={searchInput && <CloseCircleOutlined onClick={handleCancelSearch} className="site-form-item-cancel" />}
            size="large"
            className="search-bar"
            value={searchInput}
            onChange={(e) => handleSearch(e)}
          />


          <div className="button-group">
            <label className="filter-label">User Type: </label>
            {renderUserTypeOptions()}

          </div>
        </div>
        <Box id="containerBox">
          <Table
            columns={columns}
            rows={getDataSource()}
            containerId="containerBox"
            showPagination={true}
            rowSize={15}
            totalPages={
              selectedUserType === "visitor"
                ? totalVisitorFormPages
                : totalUserFormPages
            }
            currentPage={currentPage}
            updateData={(params) => handleChange({ ...params, search: searchInput })}
          />

        </Box>
        <Modal
          open={previewOpen}
          footer={null}
          onCancel={closePreviewModal}
          title="Signature"
        >
          <img
            alt="example"
            style={{ width: "100%" }}
            src={process.env.REACT_APP_API_BASE_URL + previewImage}
          />
        </Modal>
        <VisitorModal
          visibleVisitorModal={visibleVisitorModal}
          cancelModal={cancelVisitorlModal}
          propertyId={props.propertyId}
          editedVisitor={visitor}
          updateVisitorData={getVisitorForms}
        />
        {visibleCheckinUserProfileModal && (
          <CheckinUserProfileModal
            formId={selectedFormId}
            userId={checkinUserId}
            isVisible={visibleCheckinUserProfileModal}
            cancelModal={cancelCheckinUserProfileModal}
          />
        )}

        <VisitorInfoModal
          propertyId={props.propertyId}
          visibleVisitorModal={visibleVisitorInfoModal}
          cancelModal={cancelVisitorInfolModal}
          editedVisitor={visitorInfo}
          updateVisitorData={getVisitorForms}
        />

        <ViewSurveyResultModal
          visibleViewSurveyResult={visibleViewSurveyResult}
          cancelViewSurveyResult={cancelViewSurveyResult}
          surveyData={surveyResult}
          type={surveyResult?.form?.type}
        />

        <ViewServeyVisitoModal
          visibleViewSurveyResult={visibleViewServeyVisitoModal}
          cancelViewSurveyResult={cancelViewServeyVisitoModal}
          surveyData={surveyVisitorResult}
          type={surveyVisitorResult?.form?.type}
        />
      </InspectionWrapper>
    </LayoutWrapper>
  );
};

export default Inspection;